import {
  UserFullFragment,
  UserStatusEnum,
  UserTypeEnum,
  ChannelFragment,
  ChannelStatusEnum,
  PostFullFragment,
  PostStatusEnum,
} from "@/generated/generated-hooks";

type UserIndexFactor = Pick<UserFullFragment, "userType" | "userStatus">;
type ChannelIndexFactor = Pick<
  ChannelFragment,
  "channelStatus" | "isSensitive"
>;
type PostIndexFactor = Pick<PostFullFragment, "postStatus" | "isSensitive">;

export const noIndexUser = (user: UserIndexFactor) => {
  const isCreator = user.userType === UserTypeEnum.Creator;
  const isActive = user.userStatus === UserStatusEnum.Active;
  return !isCreator || !isActive;
};

export const noIndexChannel = (
  user: UserIndexFactor,
  channel: ChannelIndexFactor,
) => {
  const noindexUser = noIndexUser(user);
  const isChannelSensitive = channel.isSensitive;
  const isChannelActive = channel.channelStatus === ChannelStatusEnum.Published;
  return noindexUser || !isChannelActive || isChannelSensitive;
};

export const noIndexPost = (post: PostIndexFactor) => {
  const isSensitive = post.isSensitive;
  const isActive = post.postStatus === PostStatusEnum.Published;

  return !isActive || isSensitive;
};
